import { TextInput, TextInputProps } from '@pandiafi/design-system'
import React from 'react'

export const PinCodeTextInput: React.FC<TextInputProps> = (props) => (
  <TextInput
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    style={{
      letterSpacing: '0.2rem',
      textAlign: 'center',
      width: '100%',
    }}
    {...props}
  />
)
